import { useState } from 'react';
import Icon from '../Icon';
import { ScrollButtonRoot } from './styles';

interface ScrollButtonProps {
  icon: string;
  backgroundColor: string;
  hoverBackgroundColor: string;
  color: string;
  hoverColor: string;
  size: number;
  onClick?: () => void;
}

const ScrollButton = ({
  icon,
  backgroundColor,
  hoverBackgroundColor,
  color,
  hoverColor,
  size,
  onClick,
}: ScrollButtonProps) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  return (
    <ScrollButtonRoot
      onMouseOver={() => {
        setIsHovered(true);
      }}
      onMouseOut={() => {
        setIsHovered(false);
      }}
      $size={size}
      $backgroundColor={backgroundColor}
      $hoverBackgroundColor={hoverBackgroundColor}
      onClick={() => {
        onClick?.();
      }}
    >
      <Icon
        name={icon}
        size={size * 9}
        color={isHovered ? hoverColor : color}
        indentLess
      />
    </ScrollButtonRoot>
  );
};

export default ScrollButton;
